// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fn-0";
export var fileCarousel = "_fn-2";
export var removeFileButton = "_fn-1";